import Vue from 'vue'
import axios from 'axios'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/vue/store/mutation-type'
import store from '@/vue/store'
import Dialog from 'vant/es/dialog'

import qs from 'qs'


// 创建 axios 实例
const service = axios.create({
  //这里生产环境设置nginx内部代理
  baseURL: '/api/wap/',
  timeout: 120000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    const token = Vue.ls.get(ACCESS_TOKEN)
    //token异常
    if(error.response.status === 401) {
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 500)
        })
      }else {
        window.location.reload()
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  /*if (config.method === 'post') {
    config.data = qs.stringify(config.data)
  }*/
  //config.data = qs.stringify(config.data)
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  return response.data
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
